/** Placeholder listings until the partner furniture API is wired up. */
export const FURNITURE_CATEGORIES = [
  'All',
  'Sofa',
  'Bed',
  'Desk',
  'Chair',
  'Table',
  'Storage',
  'Appliance',
  'Other',
];

export const FURNITURE_CONDITIONS = ['Like New', 'Good', 'Fair'];

export const mockFurnitureItems = [
  {
    id: 'mock-1',
    title: 'IKEA Kivik Sofa',
    category: 'Sofa',
    price: 180,
    condition: 'Good',
    location: 'Near USC',
    image:
      'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop',
    description: 'Comfortable 3-seater sofa. Smoke-free home. Pickup preferred.',
  },
  {
    id: 'mock-2',
    title: 'Standing Desk with Monitor Arm',
    category: 'Desk',
    price: 95,
    condition: 'Like New',
    location: 'Koreatown',
    image:
      'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?w=800&h=600&fit=crop',
    description: 'Electric standing desk, barely used for one semester.',
  },
  {
    id: 'mock-3',
    title: 'Queen Mattress + Frame',
    category: 'Bed',
    price: 220,
    condition: 'Good',
    location: 'Downtown LA',
    image:
      'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800&h=600&fit=crop',
    description: 'Clean queen mattress with simple metal frame. Great for move-in.',
  },
  {
    id: 'mock-4',
    title: 'Ergonomic Office Chair',
    category: 'Chair',
    price: 65,
    condition: 'Good',
    location: 'Near USC',
    image:
      'https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=800&h=600&fit=crop',
    description: 'Adjustable lumbar support. Minor wear on armrests.',
  },
  {
    id: 'mock-5',
    title: 'Dining Table for 4',
    category: 'Table',
    price: 110,
    condition: 'Fair',
    location: 'West Adams',
    image:
      'https://images.unsplash.com/photo-1617806118233-18e1de247200?w=800&h=600&fit=crop',
    description: 'Solid wood table. Some surface scratches. Chairs not included.',
  },
  {
    id: 'mock-6',
    title: 'Bookshelf / Storage Unit',
    category: 'Storage',
    price: 40,
    condition: 'Good',
    location: 'Near USC',
    image:
      'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&h=600&fit=crop',
    description: '5-tier bookshelf. Easy to disassemble for transport.',
  },
  {
    id: 'mock-7',
    title: 'Mini Fridge',
    category: 'Appliance',
    price: 75,
    condition: 'Like New',
    location: 'University Park',
    image:
      'https://images.unsplash.com/photo-1571175443880-49e1d25b2bc5?w=800&h=600&fit=crop',
    description: 'Compact fridge, perfect for dorms or studio apartments.',
  },
  {
    id: 'mock-8',
    title: 'Floor Lamp Set',
    category: 'Other',
    price: 35,
    condition: 'Like New',
    location: 'Koreatown',
    image:
      'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=800&h=600&fit=crop',
    description: 'Two matching floor lamps. Warm light, great for studying.',
  },
];
